export class ProductSelectorModal {
    private productPageLabels: any;
    private productInfo: Product;
    private addProducts: Product[];
    private relatedProducts: Product[];
    constructor(productObj?) {
        if (productObj) {
            this.productPageLabels = productObj.productPageLabels;
            this.productInfo = productObj.productInfo;
            this.addProducts = productObj.addProducts;
            this.relatedProducts = productObj.relatedProducts;
        }
    }
    get additionalProducts() {
        return this.addProducts.map((product) => {
            return new Product(product);
        })
    }
    get primaryProduct() {
        return new Product(this.productInfo);
    }

    get relatedProductData() {
        return this.relatedProducts.map((product) => {
            return new Product(product);
        })
    }

    get pageLabels() {
        return this.productPageLabels;
    }
}


export class Product {
    productPagePath: string;
    pCode: string;
    msCode: string;
    title: string;
    categories: string;
    monthlySalary: string;
    minimumAgePrimary: string;
    minimumAgeSupplementary: string;
    minimumOdLimit: string;
    minimumAvgBalance: string;
    interestRate: any;
    interestFreeLimit: string;
    interestedIn: string;
    imageUrl: string;
    thumbnailUrl: string;
    atAGlanceTitle: string;
    summary: string;
    showComboDesc: boolean;
    summaryForCombo: string;
    circleTitleOne: string;
    circleTitleOneDescription: string;
    circleTitleTwo: string;
    circleTitleTwoDescription: string;
    websiteUrl: string;
    benefits: any[];
    keyFeatures: string[];
    odValue: string;
    odBenefits: string[];
    accountFeesLabel: string;
    accountFeesUrl: string;
    creditCardFeesLabel: string;
    creditCardFeesUrl: string;
    feesAndCharges: string;
    accountRequirement: string;
    compareAccountLabel: string;
    compareAccountUrl: string;
    compareCreditCardsLabel: string;
    compareCreditCardsUrl: string;
    optionalCardModalHeader: string;
    accountBelowBalanceFees: string;
    disclaimer: string;
    constructor(product?) {
        if (product) {
            this.productPagePath = product.productPagePath;
            this.pCode = product.pCode;
            this.msCode = product.msCode;
            this.title = product.title;
            this.categories = product.categories;
            this.monthlySalary = product.monthlySalary;
            this.minimumAgePrimary = product.monthlySalary;
            this.minimumAgeSupplementary = product.minimumAgeSupplementary;
            this.minimumOdLimit = product.minimumOdLimit;
            this.minimumAvgBalance = product.minimumAvgBalance;
            this.interestRate = product.interestRate;
            this.interestFreeLimit = product.interestFreeLimit;
            this.interestedIn = product.interestedIn;
            this.imageUrl = product.imageUrl;
            this.thumbnailUrl = product.thumbnailUrl;
            this.atAGlanceTitle = product.atAGlanceTitle;
            this.summary = product.summary;
            this.showComboDesc = product.showComboDesc;
            this.summaryForCombo = product.summaryForCombo;
            this.circleTitleOne = product.circleTitleOne;
            this.circleTitleOneDescription = product.circleTitleOneDescription;
            this.circleTitleTwo = product.circleTitleTwo;
            this.circleTitleTwoDescription = product.circleTitleTwoDescription;
            this.websiteUrl = product.websiteUrl;
            this.benefits = product.benefits;
            this.keyFeatures = product.keyFeatures;
            this.odValue = product.odValue;
            this.odBenefits = product.odBenefits;
            this.accountFeesLabel = product.accountFeesLabel;
            this.accountFeesUrl = product.accountFeesUrl;
            this.creditCardFeesLabel = product.creditCardFeesLabel;
            this.creditCardFeesUrl = product.creditCardFeesUrl;
            this.feesAndCharges = product.feesAndCharges;
            this.accountRequirement = product.accountRequirement;
            this.compareAccountLabel = product.compareAccountLabel;
            this.compareAccountUrl = product.compareAccountUrl;
            this.compareCreditCardsLabel = product.compareCreditCardsLabel;
            this.compareCreditCardsUrl = product.compareCreditCardsUrl;
            this.optionalCardModalHeader = product.optionalCardModalHeader;
            this.accountBelowBalanceFees = product.accountBelowBalanceFees;
            this.disclaimer = product.disclaimer;
        }

    }

    getBenefits() {
        let benefits = [];
        benefits = this.benefits;
        if (this.odValue == 'Y') {
            Array.prototype.push.apply(benefits, this.odBenefits);
        }
        return benefits;
    }
    setBenefits(benefits) {
        this.benefits = benefits;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/product-selector.model.ts